import React from 'react';
import { get,  } from 'lodash';
import { actionItemDetailInnerTab as ActionItemDetailInnerTabView } from 'ui/views/widgets/actionItemDetailInnerTab';
import { ActionItemDetailInnerTabService } from 'services/actionItemDetailInnerTab';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { withRouter } from 'react-router-dom';
import { DASHBOARD_SUB_ROUTES } from 'constants/route-paths';


/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { ActionItemDetailInnerTab } from 'ui/containers/ActionItemDetailInnerTab';
 *
 * // render
 * <ActionItemDetailInnerTab propName='propValue'/>
 */
class _ActionItemDetailInnerTab extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        // bind methods
        this.handleViewActionClick = this.handleViewActionClick.bind( this );

        this.actionItemDetailInnerTabService = new ActionItemDetailInnerTabService();

        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
            actionId: this.props.actionId
        };
        
        this.fetchComponentData(); // start component data fetch
        
    }

    /**
	 * @desc Fetch component response.
	 */
    async fetchComponentData() {
        log.debug( 'ActionItemDetailInnerTab.fetchComponentData()' );
        // cancel ongoing request
        this.actionItemDetailInnerTabService.cancel();

        // get status and service data
        const { status, data } = await this.actionItemDetailInnerTabService.fetchComponentData( {
            url: this.props.widget.url,
            data: { ...this.props.requestPayload }
        } );

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
            } );
        } else {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                componentData: data,
            } );
        }
    }

    /**
     * @desc On tab action click
     */
    handleViewActionClick( { tab, action } = {} ) {
        log.debug( 'ActionItemDetailInnerTab.handleViewActionClick()' );
        // redirect to member management page
        if( 'view' === action.name ) {
            this.props.history.push( {
                pathname: DASHBOARD_SUB_ROUTES.MEMBER_MANAGEMENT,
                state: { memberId: tab.id, patientId: tab.patientId }
            } );
        }
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <ActionItemDetailInnerTabView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                { ...get( this.state, 'componentData', {} ) }
                requestPayload={ this.props.requestPayload }
                actionId={ this.state.actionId }
                onViewActionClick={ this.handleViewActionClick }
            />
        );
    }
}

// set display name
_ActionItemDetailInnerTab.displayName = '_ActionItemDetailInnerTab';

// set default props
_ActionItemDetailInnerTab.defaultProps = {};

// prop types
_ActionItemDetailInnerTab.propTypes = {};

// wrap with router
export const ActionItemDetailInnerTab = withRouter( _ActionItemDetailInnerTab );
